"use client";

import { Button } from "@/components/Button";
import { getDataAutomationGroup, getDataAutomationId } from "@/helpers";
import { FC, useState } from "react";
import cn from "classnames";
import styles from "./SubnetCalculator.module.css";

interface SubnetsTableProps {
  headline: string;
  addresses: Array<Array<string>>;
  parentElement: HTMLElement | null;
}

export const SubnetsTable: FC<SubnetsTableProps> = ({
  headline,
  addresses,
  parentElement,
}) => {
  const [showMore, setShowMore] = useState(false);

  const onClick = () => {
    if (showMore) {
      parentElement?.scrollIntoView({
        behavior: "smooth",
      });
    }
    setShowMore((prev) => !prev);
  };

  const renderedAddresses = showMore ? addresses : addresses.slice(0, 20);

  return (
    <div className="flex flex-col">
      <div className={cn("mt-10", styles.scroller)}>
        <table
          className="text-swdc-gray-400 text-body-s w-full min-w-205 table-fixed border-collapse bg-white"
          {...getDataAutomationGroup("table")}
          {...getDataAutomationId("all-subnets-section")}
        >
          <caption className="text-subhead-2xs sm:text-subhead-xs text-swdc-black-600 mb-5 text-left font-bold">
            {headline}
          </caption>
          <thead>
            <tr className="text-swdc-black-600 text-left font-bold">
              <th className="border-swdc-silver-400 w-1/5 border p-2">
                Subnet
              </th>
              <th className="border-swdc-silver-400 w-1/5 border p-2">
                Start Address
              </th>
              <th className="border-swdc-silver-400 w-1/5 border p-2">
                End Address
              </th>
              <th className="border-swdc-silver-400 w-1/5 border p-2">
                Network Address
              </th>
              <th className="border-swdc-silver-400 w-1/5 border p-2">
                Broadcast Address
              </th>
            </tr>
          </thead>
          <tbody>
            {renderedAddresses.map((row, rowIndex) => (
              <tr key={`row-${rowIndex}`}>
                {row.map((col, colIndex) => (
                  <td
                    key={`col-${rowIndex}-${colIndex}`}
                    className="border-swdc-silver-400 border p-2"
                  >
                    {col}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {addresses.length > 20 ? (
        <Button
          variant="tertiary"
          size="m"
          icon={showMore ? "arrowUp" : "arrowDown"}
          className="mt-10 self-center"
          onClick={onClick}
          {...getDataAutomationId(
            showMore ? "see-less-subnets" : "see-all-subnets",
          )}
        >
          {showMore ? "See less Subnets" : "See all Subnets"}
        </Button>
      ) : null}
    </div>
  );
};
